import React from "react"
import { UserImportFieldOptionsModel } from "../../../models/ApiResponseModels/UserImportFieldOptionsModel"
import { UserUploadActionProgress } from "../../../models/ApiResponseModels/UserUploadActionProgressModel"

import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import Step4 from './Step4'
import Step5 from './Step5'
import { UserImportType } from "@/models/UserImportType"
import { UserImportStep } from "@/models/UserImportStep"

interface StepProps {
    userImportOptions: UserImportFieldOptionsModel[]
    setFile: (value: HTMLInputElement) => void
    progressReport: UserUploadActionProgress
    SetValid: (value: boolean) => void
    currentStep: UserImportStep
    setUserImportOptions: (value: UserImportFieldOptionsModel[]) => void
    responseError: {message: string, code: number}
    setUploadType:(type: UserImportType)=> void
    uploadType:UserImportType
}

const Step = ({userImportOptions, setFile, progressReport, SetValid, currentStep, setUserImportOptions, responseError, setUploadType, uploadType}: StepProps) => {
    switch (currentStep){
        case UserImportStep.ImportTypeSelection:
            SetValid(true)
            return <Step1 
            setUploadType = {setUploadType}
            uploadType = {uploadType}
            />
        case UserImportStep.FileUpload:
            return <Step2 
                setFile = {setFile} 
                setValid = {SetValid}  
            />
        case UserImportStep.UserOptions:
            SetValid(true)
            return <Step3
                userImportOptions = {userImportOptions}
                setUserImportOptions= {setUserImportOptions}
                responseError = {responseError}
            />
        case UserImportStep.Validation:
            SetValid(true)
            return <Step4 progressReport = {progressReport} />
        case UserImportStep.ReviewAndApplyChanges:
            SetValid(true)
            return <Step5 progressReport = {progressReport} userImportType={uploadType} />
    }
}

export default Step